<div class="toaster position-fixed top-0 end-0 px-3 py-2 m-16">
  @for (toast of toastEvents; track toast; let i = $index) {
    <div>
      <app-toast [toastEvent]="toast" (dispose)="dispose(i)"></app-toast>
    </div>
  }
</div>